import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "image", "redundant"]

  connect() {
    this.adjustTextHeight()
    window.addEventListener('resize', this.adjustTextHeight.bind(this))
  }

  disconnect() {
    window.removeEventListener('resize', this.adjustTextHeight.bind(this))
  }

  adjustTextHeight() {
    if (!this.hasTextTarget || !this.hasImageTarget) return

    const textElement = this.textTarget
    const imageElement = this.imageTarget
    const imageHeight = imageElement.offsetHeight
    const redundantHeight = this.calRedundantElementHeight(this.redundantTarget)
    const textMaxHeight = imageHeight - redundantHeight

    // 重置樣式以獲取原始高度
    this.resetTextElementStyle(textElement)

    if (imageHeight === 0) {
      // 圖片尚未載入，等待載入完成
      imageElement.addEventListener('load', () => {
        this.adjustTextHeight()
      }, { once: true })
      return
    }

    if (textElement.scrollHeight > textMaxHeight) {
      this.setAdjustedStyle(textElement, textMaxHeight)
      this.setWebkitLineClamp(textElement, textMaxHeight)
    }
  }

  resetTextElementStyle(textElement) {
    textElement.style.display = 'block'
    textElement.style.overflow = 'visible'
    textElement.style.webkitLineClamp = 'unset'
  }

  setAdjustedStyle(textElement, textMaxHeight) {
    textElement.style.display = '-webkit-box'
    textElement.style.webkitBoxOrient = 'vertical'
    textElement.style.overflow = 'hidden'
    textElement.style.maxHeight = `${textMaxHeight}px`
  }

  setWebkitLineClamp(textElement, textMaxHeight) {
    // 計算需要顯示的行數
    const lineHeight = parseFloat(window.getComputedStyle(textElement).lineHeight)
    const visibleMarginBottomHeight = this.calMarginBottomHeight(textElement, textMaxHeight)
    const adjustedTextHeight = textMaxHeight - visibleMarginBottomHeight
    const lines = Math.floor(adjustedTextHeight / lineHeight)

    textElement.style.webkitLineClamp = lines > 0 ? lines : 1
  }

  calRedundantElementHeight(redundantTarget) {
    const elementHeight = redundantTarget.offsetHeight
    const styles = window.getComputedStyle(redundantTarget)
    const marginTop = parseFloat(styles.marginTop)
    const marginBottom = parseFloat(styles.marginBottom)
    
    return elementHeight + marginTop + marginBottom
  }

  // 計算 textMaxHeight 範圍內的元素及其 margin-bottom (空行的空間跟文字的空間不同)
  calMarginBottomHeight(textElement, textMaxHeight) {
    const children = Array.from(textElement.children)
    let accumulatedHeight = 0
    let visibleMarginBottom = 0

    for (const child of children) {
      const childHeight = child.offsetHeight
      const marginBottom = parseFloat(window.getComputedStyle(child).marginBottom)

      // 檢查元素是否為空（沒有文字內容的 margin 不佔空間）
      const isEmpty = child.textContent.trim() === ''
      if (isEmpty) { continue }

      if (accumulatedHeight + childHeight + marginBottom <= textMaxHeight) {
        accumulatedHeight += childHeight + marginBottom
        visibleMarginBottom += marginBottom
      } else {
        break
      }
    }

    return visibleMarginBottom
  }
}
